module.exports = __webpack_public_path__ + "img/webbankir.d41ed52a.svg";